import React from 'react'
import HintPopover from "../../../../core/gd-ui/hint-popover/hint-popover"

type Props = {
    className?      : string,
    iconClass?      : string,
    label?          : string,

    hint            : string,
    size            : '24' | '26' | '28',
    fontSize        : '11'|'12'|'13'|'14'|'15'|'16'|'18'|'20'|'24'

    isSelected?     : boolean,
    isSelectedNoBg? : boolean,
    disabled?       : boolean,

    color?          : 'hint' | 'blue',      // &.color class...

    onClick         : callback,
    children?       : any
}

export default class UI5ControlButton extends React.Component<Props> {

    static defaultProps: Partial<Props> = {
        size    : '26',
        fontSize: '13'
    }

    onClick = (e: any) => {
        e.stopPropagation()

        if (this.props.disabled) return;
        const newValue = !this.props.isSelected;
        if (this.props.onClick) this.props.onClick(newValue);
    }

    render() {
        const classes = Classes('ui5-control-button', 's-{0}'.f(this.props.size), 'fs-{0}'.f(this.props.fontSize), this.props.color, this.props.className, {
            'selected'      : this.props.isSelected,
            'selected-no-bg': this.props.isSelectedNoBg,
            'disabled'      : this.props.disabled
        })

        const iconClasses = Classes('icon', this.props.iconClass, {
            'm-l-5 m-r-8': !!this.props.label
        })

        const labelClass = Classes("label m-r-5", {
            'm-l-5'     : !this.props.iconClass
        })

        return (
            <div className={classes} onClick={this.onClick}>
                {this.props.children}
                {!!this.props.iconClass &&
                    <div className={iconClasses}/>
                }
                {!!this.props.label && <div className={labelClass}>
                    {this.props.label}</div>
                }
                <HintPopover parent={this} hint={this.props.hint}/>
            </div>
        );
    }
}
